import { gql } from 'apollo-boost'
import { checkout } from './fragments'

const mutation = gql`
  mutation applyCheckoutDiscountCode($discountCode: String!, $checkoutId: ID!) {
    checkoutDiscountCodeApplyV2(
      discountCode: $discountCode
      checkoutId: $checkoutId
    ) {
      checkout {
        ...ShopifyCheckout
      }
    }
  }
  ${checkout}
`

export const applyCheckoutDiscountCode = (client, variables) =>
  client.mutate({ mutation, variables })

export default applyCheckoutDiscountCode
